import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { createPinia } from 'pinia'
import '@/axios.config'
import '@finetic/bikefitting-ui/dist/index.css'

const pinia = createPinia()

createApp(App).use(pinia).use(router).use(i18n).mount('#app')
